/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { Cell } from 'rsuite-table'
import EditIcon from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import VisibleIcon from '@rsuite/icons/Visible'
import ShareOutlineIcon from '@rsuite/icons/ShareOutline'
import { RiSecurePaymentFill } from 'react-icons/ri'
import CopyIcon from '@rsuite/icons/Copy'
import DocPassIcon from '@rsuite/icons/DocPass'
import { Whisper, Tooltip } from 'rsuite'
import './ActionCell.scss'
import {
  MdNotificationsActive,
  MdLocalFlorist,
  MdFileDownload
} from 'react-icons/md'

type Props = {
  rowData?: any,
  dataKey: string,
  onAction?: (eventKey: string | undefined, rowData: any) => void,
  actionOptions?: string[],
  tooltip?: boolean,
  disableEdit?: boolean
}

const defaultProps = {
  rowData: undefined,
  actionOptions: [],
  onAction: () => {},
  disableEdit: false
}

const defaultOptions = [
  { label: 'View', eventKey: '1', icon: <VisibleIcon /> },
  { label: 'Edit', eventKey: '2', icon: <EditIcon /> },
  { label: 'Delete', eventKey: '3', icon: <TrashIcon /> },
  { label: 'Share', eventKey: '4', icon: <ShareOutlineIcon /> },
  {
    label: 'Send Notification',
    eventKey: '5',
    icon: <MdNotificationsActive />
  },
  { label: 'View Farms', eventKey: '6', icon: <MdLocalFlorist /> },
  { label: 'Download Transaction', eventKey: '7', icon: <MdFileDownload /> },
  { label: 'Make Payment', eventKey: '8', icon: <RiSecurePaymentFill /> },
  { label: 'Copy Compaign', eventKey: '9', icon: <CopyIcon /> },
  { label: 'Verification', eventKey: '10', icon: <DocPassIcon /> }
]

const ActionCell: React.FC<Props> = ({
  rowData,
  dataKey,
  actionOptions = [],
  tooltip,
  disableEdit = false,
  ...props
}) => {
  const optionsToDisplay =
    actionOptions.length > 0
      ? defaultOptions.filter((option) => actionOptions.includes(option.label))
      : defaultOptions

  const handleActionClick = (eventKey: string | undefined) => {
    if (!eventKey || typeof props.onAction !== 'function') return
    if (
      eventKey === '2' &&
      (rowData?.status === 'Schedule' || rowData?.status === 'Process') &&
      disableEdit
    ) {
      return
    }

    props.onAction(eventKey, rowData)
  }
  const getEditTooltipMessage = (
    isDisabled: boolean,
    option: { label: string }
  ) => {
    if (!isDisabled) return option.label

    if (rowData?.status === 'Schedule') {
      return 'Cannot edit a scheduled campaign'
    }
    if (rowData?.status === 'Process') {
      return 'Cannot edit a campaign in process'
    }
    return option.label
  }

  return (
    <Cell {...props} className="link-group">
      <div className="action-icons-wrapper">
        {optionsToDisplay.map((option) => {
          const isDisabled =
            option.eventKey === '2' &&
            (rowData?.status === 'Schedule' || rowData?.status === 'Process') &&
            disableEdit

          return (
            <div
              key={option.eventKey}
              className={`action-icon ${isDisabled ? 'disabled' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => !isDisabled && handleActionClick(option.eventKey)}
              onKeyDown={(e) => {
                if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
                  handleActionClick(option.eventKey)
                }
              }}
            >
              {tooltip ? (
                <Whisper
                  placement="bottom"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      {getEditTooltipMessage(isDisabled, option)}
                    </Tooltip>
                  }
                >
                  <div className="icon-container">{option.icon}</div>
                </Whisper>
              ) : (
                <div className="icon-container">{option.icon}</div>
              )}
            </div>
          )
        })}
      </div>
    </Cell>
  )
}

ActionCell.defaultProps = defaultProps

export default ActionCell
